import { Injectable } from '@angular/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

/**
 * Service wrapper based on ngx-device-detector providing custom functionality. The original service provides
 * info about host OS, device, browser, ...
 *
 * https://www.npmjs.com/package/ngx-device-detector
 */

@Injectable()
export class DeviceCheckerService {

    constructor(private deviceService: DeviceDetectorService) { }

    /**
     * If browser is internet explorer.
     */
    public isIE() {
        let deviceInfo: DeviceInfo = this.deviceService.getDeviceInfo();
        return deviceInfo.browser === 'ie';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/services/device-checker.service.ts